import JQueryView, { on } from '../../../common/views/jqueryView';

// エンジェル投資セミナーのポップアップ（my/investors/_angel_seminar2610_event_modal）を開き、× クリックで dismiss cookie をセットして12時間抑制する。
// 手続きを求めるモーダル（規約再同意・特定投資家更新は 15 分）と違い案内のポップアップのため、依頼者と合意した 12 時間にしている。
// モーダル自体の close は Bootstrap の data-dismiss="modal" が担当する。
const DISMISS_COOKIE_NAME = 'angel_seminar2610_event_modal_dismissed';
const DISMISS_MAX_AGE_SECONDS = 60 * 60 * 12; // 12 hours

export default class AngelSeminar2610EventModalView extends JQueryView {
  constructor() {
    super('#angel_seminar2610_event_modal');

    // 「戻る」でブラウザが保存済みの HTML を描画し直すと、閉じた後でもサーバー側の判定を経ずにここに来るため、開く前に cookie を見る
    if (this.$el.length === 0 || AngelSeminar2610EventModalView.isDismissed()) {
      return;
    }
    this.$el.modal('show');
  }

  private static isDismissed(): boolean {
    return document.cookie.split('; ').includes(`${DISMISS_COOKIE_NAME}=1`);
  }

  @on({ event: 'click', selector: '.js-angel-seminar2610-event-modal-close' })
  onClickClose() {
    // HTTPS 配信時のみ Secure を付与。HTTP の dev 環境では Secure 付き cookie は保存されないため条件分岐する
    const secureAttr = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${DISMISS_COOKIE_NAME}=1; path=/; Max-Age=${DISMISS_MAX_AGE_SECONDS}; SameSite=Lax${secureAttr}`;
  }
}
